import { getDate } from '@composables/utils/dateUtils'
import { sendToGA } from '@composables/utils/googleAnalyticsUtil'
import { datadogLogs } from '@datadog/browser-logs'
import { useRequest } from '@/stores/request'

const env = import.meta.env

const globalCtx = {
  env: env.VITE_APP_ENVIRONMENT,
  app_name: env.VITE_APP_NAME
}

export function getGlobalCtx() {
  return globalCtx
}

function formatMessage(attrs) {
  const userIdentifier =
    attrs.context?.client_name != null
      ? `Cliente: ${attrs.context?.client_name}`
      : `installation_id: ${getGlobalCtx().installation_id}`
  let msg = `[${attrs.level.toUpperCase()}] ${userIdentifier} – ${String(attrs.context.log_type ?? '')}`
  if (Object.hasOwn(attrs, 'error_info')) {
    msg += ' - ' + attrs.error_info.message
  }
  return msg
}

export class Logger {
  constructor(name = 'app') {
    this.name = name
  }
  bind(ctx = {}) {
    Object.assign(globalCtx, ctx)
  }
  _emit(level, payload = {}) {
    const logCtx = { ...payload.context }
    let attrs = {}

    if (logCtx.error != null) {
      attrs.error_info = {
        name: logCtx.error.name,
        message: logCtx.error.message,
        stack: logCtx.error.stack
      }
      delete logCtx.error
    }

    if (useRequest().hasRequestId) {
      attrs.request_id = useRequest().requestId
    }

    attrs = {
      ...attrs,
      ...globalCtx,
      logger_name: payload?.name != null ? payload.name : this.name,
      context: {
        ...globalCtx.context,
        ...logCtx,
        log_type: payload.message
      },
      level: level,
      module: payload.module,
      func_name: payload.func_name,
      timestamp: getDate()
    }

    const msg = formatMessage(attrs)
    attrs.message = msg

    datadogLogs.logger.log(msg, attrs, level !== 'analytics' ? level : 'info')
    if (level === 'analytics') {
      sendToGA(attrs.context.log_type, attrs)
    }
    if (env.VITE_APP_ENVIRONMENT !== 'prod') {
      let consoleColor
      switch (level) {
        case 'error':
          consoleColor = '#dc3545'
          break
        case 'warning':
          consoleColor = '#ffc107'
          break
        case 'debug':
          consoleColor = '#6c757d'
          break
        case 'analytics':
          consoleColor = '#007bff'
          break
        default:
          consoleColor = '#17a2b8'
      }
      console.log(
        `%c${level}%c  ${msg}`,
        `background: ${consoleColor}; color: white; font-weight: bold; padding: 1px 4px; border-radius: 4px;`,
        'color: inherit; font-weight: normal;',
        {
          ...attrs
        }
      )
    }
    return
  }
  debug(ctx) {
    this._emit('debug', ctx)
  }
  info(ctx) {
    this._emit('info', ctx)
  }
  warn(ctx) {
    this._emit('warning', ctx)
  }
  analytics(ctx) {
    this._emit('analytics', ctx)
  }
  error(ctx) {
    this._emit('error', ctx)
  }
}

export const log = new Logger('app')
